import React, { useState } from "react";
import {
    Grid,
    Paper,
    Typography,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TableContainer,
} from "@mui/material";
import Select, { components } from "react-select";
import ZoomWrapper from "utils/ZoomWrapper";
import Loader from "utils/Loader";
import CollectionTargetAchvReportController from "pages/Controller/CollectionTargetAchvReportController";
import CollectionTargetAchvBarChart from "./Charts/CollectionTargetAchvBarChart";

const addSelectAllOption = (options) => [
    { label: "Select All", value: "__ALL__", isSelectAll: true },
    ...options
];

/* ================= CHECKBOX OPTION (REUSABLE) ================= */
const CheckboxOption = (props) => {
    const { label, amount, isSelectAll } = props.data;
    const { isSelected, selectOption, getValue } = props;

    // 🔥 FORCE Select-All checked state
    const allSelected =
        isSelectAll &&
        getValue().length > 0 &&
        getValue().length === props.options.filter(o => !o.isSelectAll).length;

    const checked = isSelectAll ? allSelected : isSelected;

    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        selectOption(props.data);
    };

    return (
        <button
            type="button"
            onMouseDown={handleClick}
            style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "6px 10px",
                cursor: "pointer",
                background: isSelectAll ? "#f5f5f5" : "#fff",
                color: "#000",
                border: "none",
                width: "100%",
                textAlign: "left",
                fontSize: "13px"
            }}
        >
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <input
                    type="checkbox"
                    checked={checked}
                    readOnly
                    style={{ width: 14, height: 14 }}
                />
                <span style={{ color: "#000", fontWeight: 400 }}>{label}</span>
            </div>

            {amount && (
                <span style={{ fontSize: "12px", color: "#b1005a", fontWeight: 600 }}>
                    {amount}
                </span>
            )}
        </button>
    );
};

const CollectionTargetAchvReport = () => {
    const {
        cloading,
        divisionOptions,
        zoneOptions,
        filters,
        handleFilterChange
    } = CollectionTargetAchvReportController();


    /* ================= MONTH (DUMMY) ================= */
    const monthOptions = [
        { label: "APR", value: "APR" },
        { label: "MAY", value: "MAY" },
        { label: "JUN", value: "JUN" }
    ];

    const [month, setMonth] = useState([]);

    /* ================= KPI DATA (DUMMY) ================= */
    const kpi = {
        target: 83758.29,
        received: 77242.46,
        achieved: 92.22
    };

    /* ================= WEEK SUMMARY TABLE (DUMMY) ================= */
    const weekSummary = [{ week: "Week 1", target: 16330.33, received: 15314.36, achv: "93.78%" }, { week: "Week 2", target: 19929.94, received: 19045.9, achv: "95.56%" }, { week: "Week 3", target: 22870.08, received: 18225.07, achv: "79.69%" }, { week: "Week 4", target: 24627.94, received: 24657.13, achv: "100.12%" }];
    const barChartData = weekSummary.map(w => ({
        week: w.week,
        target: w.target,
        received: w.received
    }));


    /* ================= AREA TABLE (DUMMY) ================= */
    const areaRows = [
        {
            zone: "AGRA",

            w1_target: 421.27,
            w1_received: 1110.67,

            w2_target: 678.07,
            w2_received: 1063.53,

            w3_target: 815.24,
            w3_received: 1102.42,

            w4_target: 820.20,
            w4_received: 1387.66,

            total_target: 2734.78,
            total_received: 4664.28
        },
        {
            zone: "AHMEDABAD",

            w1_target: 442.22,
            w1_received: 391.19,

            w2_target: 612.73,
            w2_received: 598.13,

            w3_target: 739.34,
            w3_received: 546.91,

            w4_target: 781.90,
            w4_received: 710.89,

            total_target: 2576.19,
            total_received: 2247.12
        },
        {
            zone: "BENGALURU",

            w1_target: 835.50,
            w1_received: 912.10,

            w2_target: 1020.25,
            w2_received: 1112.40,

            w3_target: 980.75,
            w3_received: 967.30,

            w4_target: 1315.60,
            w4_received: 1236.10,

            total_target: 4152.10,
            total_received: 4227.90
        }
    ];


    const NoMultiValue = () => null;

    const singleLineSelectStyles = {
        menuPortal: (b) => ({ ...b, zIndex: 9999 }),
        control: (base) => ({
            ...base,
            minHeight: 38,
            height: 38
        }),
        valueContainer: (base) => ({
            ...base,
            height: 38,
            padding: "0 8px",
            overflow: "hidden"
        }),
        placeholder: (base) => ({
            ...base,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "100%",
            color: "#000",
            fontWeight: 500
        }),
        indicatorsContainer: (base) => ({
            ...base,
            height: 38
        })
    };

    const [zoneSearchText, setZoneSearchText] = useState("");
    const [subdivisionSearchText, setSubdivisionSearchText] = useState("");

    const makeClearTextOnlyIndicator = (setText) =>
        function ClearTextOnlyIndicator(props) {
            return (
                <components.ClearIndicator
                    {...props}
                    innerProps={{
                        ...props.innerProps,
                        onMouseDown: (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setText("");
                        }
                    }}
                />
            );
        };

    const ZoneClearIndicator = makeClearTextOnlyIndicator(setZoneSearchText);
    const SubdivisionClearIndicator = makeClearTextOnlyIndicator(setSubdivisionSearchText);

    const [isZoneOpen, setIsZoneOpen] = useState(false);
    const [isSubdivisionOpen, setIsSubdivisionOpen] = useState(false);

    const safeZones = Array.isArray(filters.zone) ? filters.zone : [];
    const safeDivisions = Array.isArray(filters.division) ? filters.division : [];

    //zone dropdown-
    const excludedZones = zoneOptions.filter(
        (z) => !safeZones.some((s) => s.value === z.value)
    );

    const selectedZoneCount = safeZones.length;

    const zonePlaceholder = isZoneOpen
        // ? `ZONE${excludedZones.length ? ` Excluded (${excludedZones.length})` : ""}`
        ? `ZONE${selectedZoneCount ? ` selected (${selectedZoneCount})` : ""}`
        : excludedZones.length
            ? `ZONE: Excluded: ${excludedZones.map(z => z.label).join(", ").slice(0, 45)
            }${excludedZones.map(z => z.label).join(", ").length > 45 ? "..." : ""}`
            : "ZONE";

    const zoneTooltip =
        excludedZones.length ? `Excluded:\n${excludedZones.map(z => z.label).join("\n")}` : "";

    //subdivision dropdown-
    // DIVISION DROPDOWN
    const excludedDivisions = divisionOptions.filter(
        (d) => !safeDivisions.some((s) => s.value === d.value)
    );

    const selectedDivisionCount = safeDivisions.length;

    const divisionPlaceholder = isSubdivisionOpen
        ? `DIVISION${selectedDivisionCount ? ` selected (${selectedDivisionCount})` : ""}`
        : excludedDivisions.length
            ? `DIVISION: Excluded: ${excludedDivisions
                .map(d => d.label)
                .join(", ")
                .slice(0, 45)
            }${excludedDivisions.map(d => d.label).join(", ").length > 45 ? "..." : ""}`
            : "DIVISION";

    const divisionTooltip =
        excludedDivisions.length
            ? `Excluded:\n${excludedDivisions.map(d => d.label).join("\n")}`
            : "";

    /* ================= SELECT ALL HANDLERS ================= */

    // ZONE
    const handleZoneChange = (selected) => {
        if (!selected) {
            handleFilterChange("zone")([]);
            return;
        }

        if (selected.some(o => o.value === "__ALL__")) {
            const allSelected =
                safeZones.length === zoneOptions.length;

            handleFilterChange("zone")(
                allSelected ? [] : zoneOptions
            );
            return;
        }

        handleFilterChange("zone")(selected);
    };



    // SUBDIVISION
    const handleDivisionChange = (selected) => {
        if (!selected) {
            handleFilterChange("division")([]);
            return;
        }

        if (selected.some(o => o.value === "__ALL__")) {
            const allSelected =
                safeDivisions.length === divisionOptions.length;

            handleFilterChange("division")(
                allSelected ? [] : divisionOptions
            );
            return;
        }

        handleFilterChange("division")(selected);
    };

    //grandtotal
    const totalTarget = weekSummary.reduce(
        (sum, r) => sum + Number(r.target || 0),
        0
    );

    const totalReceived = weekSummary.reduce(
        (sum, r) => sum + Number(r.received || 0),
        0
    );

    const totalAchv =
        totalTarget > 0
            ? ((totalReceived / totalTarget) * 100).toFixed(2)
            : 0;


    return (
        <ZoomWrapper>
            <div className="bg" style={{ display: "block" }}>
                {/* ---------- LOADER ---------- */}
                {cloading && (
                    <div className="overlay">
                        <Loader />
                        <span style={{ marginLeft: 10 }}>Data loading...</span>
                    </div>
                )}

                {/* ---------- PAGE TITLE ---------- */}
                <div style={{ textAlign: "center" }}>
                    <span className="font20">COLLECTION TARGET VS ACHIEVEMENT</span>
                </div>

                <div className="orderrow"></div>

                {/* ---------- INFO HEADER ---------- */}
                <Paper elevation={2} sx={{ p: 2, mb: 2 }}>
                    <Typography
                        variant="body1"
                        sx={{ textAlign: "center", color: "#444" }}
                    >
                        AREA WISE TARGET VS ACHIEVEMENT (COLLECTION) (THIS REPORT BASED ON ONLY RECIEVED COLLECTION) YEAR 2025-26 (SSML ALL DIVISION) UPDATED AS ON 30.12.2025
                    </Typography>
                </Paper>

                {/* ================= FILTERS + KPI ================= */}
                <Grid container spacing={2} sx={{ mb: 3 }}>
                    {/* DIVISION */}
                    <Grid item xs={12} md={2}>
                        <div title={divisionTooltip}>
                            <Select
                                options={addSelectAllOption(divisionOptions || [])}
                                value={safeDivisions}
                                onChange={handleDivisionChange}

                                inputValue={subdivisionSearchText || ""}
                                onInputChange={(val, { action }) => {
                                    if (action === "input-change") {
                                        setSubdivisionSearchText(val);
                                    }
                                    if (action === "menu-close") {
                                        return "";
                                    }
                                    if (action === "set-value") {
                                        return subdivisionSearchText;
                                    }
                                    return val;
                                }}

                                isMulti
                                isClearable={Boolean(subdivisionSearchText)}
                                closeMenuOnSelect={false}
                                hideSelectedOptions={false}
                                controlShouldRenderValue={false}

                                components={{
                                    Option: CheckboxOption,
                                    MultiValue: NoMultiValue,
                                    ClearIndicator: SubdivisionClearIndicator
                                }}

                                placeholder={divisionPlaceholder}
                                onMenuOpen={() => setIsSubdivisionOpen(true)}
                                onMenuClose={() => {
                                    setIsSubdivisionOpen(false);
                                    setSubdivisionSearchText("");   // ✅ important reset
                                }}
                                styles={singleLineSelectStyles}
                                menuPortalTarget={document.body}
                            />


                        </div>

                    </Grid>

                    {/* ZONE */}
                    <Grid item xs={12} md={2}>
                        <div title={zoneTooltip}>
                            <Select
                                options={addSelectAllOption(zoneOptions || [])}
                                value={safeZones}
                                onChange={handleZoneChange}

                                inputValue={zoneSearchText || ""}
                                onInputChange={(val, { action }) => {
                                    if (action === "input-change") {
                                        setZoneSearchText(val);
                                    }
                                    if (action === "menu-close") {
                                        return "";    // ✅ reset filter when menu closes
                                    }
                                    if (action === "set-value") {
                                        return zoneSearchText;
                                    }
                                    return val;
                                }}

                                isMulti
                                isClearable={Boolean(zoneSearchText)}
                                closeMenuOnSelect={false}
                                hideSelectedOptions={false}
                                controlShouldRenderValue={false}

                                components={{
                                    Option: CheckboxOption,
                                    MultiValue: NoMultiValue,
                                    ClearIndicator: ZoneClearIndicator
                                }}

                                placeholder={zonePlaceholder}
                                onMenuOpen={() => setIsZoneOpen(true)}
                                onMenuClose={() => {
                                    setIsZoneOpen(false);
                                    setZoneSearchText("");     // ✅ important reset
                                }}
                                styles={singleLineSelectStyles}
                                menuPortalTarget={document.body}
                            />


                        </div>
                    </Grid>


                    {/* MONTH (DUMMY ONLY) */}
                    <Grid item xs={12} md={2}>
                        <Select
                            options={addSelectAllOption(monthOptions)}
                            isMulti
                            value={month}
                            onChange={setMonth}
                            placeholder="MONTH"
                        />
                    </Grid>

                    {/* KPI CARDS */}
                    <Grid item xs={12} md={6}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={4}>
                                <Paper sx={{ p: 1, textAlign: "center", background: "#7b003f", color: "#fff" }}>
                                    <Typography variant="body2">COLLECTION TARGET</Typography>
                                    <Typography variant="h6">{kpi.target.toLocaleString()}</Typography>
                                </Paper>
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <Paper sx={{ p: 1, textAlign: "center", background: "#f5b400", color: "#000" }}>
                                    <Typography variant="body2">COLLECTION RECEIVED</Typography>
                                    <Typography variant="h6">{kpi.received.toLocaleString()}</Typography>
                                </Paper>
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <Paper sx={{ p: 1, textAlign: "center", background: "#4caf50", color: "#fff" }}>
                                    <Typography variant="body2">ACHIEVED %</Typography>
                                    <Typography variant="h6">{kpi.achieved}%</Typography>
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                {/* ================= CHART + WEEK TABLE ================= */}
                <Grid container spacing={2} sx={{ mb: 3 }}>
                    {/* BAR CHART */}
                    <Grid item xs={12} md={7}>
                        <Paper elevation={3} sx={{ p: 1 }}>
                            <Typography sx={{ fontWeight: 600, mb: 1 }}>
                                WEEK WISE APR-DEC TARGET VS ACHIEVEMENT
                            </Typography>
                            <CollectionTargetAchvBarChart data={barChartData} />

                        </Paper>
                    </Grid>

                    {/* WEEK SUMMARY TABLE */}
                    <Grid item xs={12} md={5}>
                        <Typography
                            variant="body1"
                            sx={{ color: "#ffffff", fontWeight: 600, mb: 1 }}
                        >
                            WEEK WISE APR-DEC TARGET VS ACHIEVEMENT
                        </Typography>
                        <Paper elevation={3}>

                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={{ background: "#eee" }}>
                                        <TableCell>WEEK</TableCell>
                                        <TableCell align="right">COLLECTION TARGET</TableCell>
                                        <TableCell align="right">COLLECTION RECEIVED</TableCell>
                                        <TableCell align="right">ACHV %</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {weekSummary.map((r, i) => (
                                        <TableRow key={i}>
                                            <TableCell>{r.week}</TableCell>
                                            <TableCell align="right">{r.target}</TableCell>
                                            <TableCell align="right">{r.received}</TableCell>
                                            <TableCell align="right">{r.achv}</TableCell>
                                        </TableRow>
                                    ))}
                                    {/* ✅ GRAND TOTAL ROW */}
                                    <TableRow sx={{ backgroundColor: "#f5f5f5", fontWeight: 700 }}>
                                        <TableCell><b>Grand Total</b></TableCell>

                                        <TableCell align="right">
                                            <b>{totalTarget.toLocaleString("en-IN")}</b>
                                        </TableCell>

                                        <TableCell align="right">
                                            <b>{totalReceived.toLocaleString("en-IN")}</b>
                                        </TableCell>

                                        <TableCell align="right">
                                            <b>{totalAchv}%</b>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </Paper>
                    </Grid>
                </Grid>

                {/* ================= AREA WISE TABLE ================= */}
                <Typography
                    variant="body1"
                    sx={{ color: "#ffffff", fontWeight: 500, mb: 1 }}
                >
                    AREA WISE & WEEK WISE TARGET VS ACHIEVEMENT
                </Typography>

                <Paper>
                    <TableContainer sx={{ maxHeight: 420 }}>
                        <Table stickyHeader size="small">
                            <TableHead>

                                {/* ===== TOP GROUP HEADER ===== */}
                                <TableRow>
                                    <TableCell rowSpan={3}>
                                        <b>ZONE</b>
                                    </TableCell>

                                    <TableCell align="right" colSpan={10}>
                                        <b>WEEK / COLLECTION TARGET / COLLECTION RECEIVED</b>
                                    </TableCell>
                                </TableRow>

                                {/* ===== WEEK GROUP HEADER ===== */}
                                <TableRow>
                                    <TableCell align="right" colSpan={2}>
                                        <b>Week 1</b>
                                    </TableCell>
                                    <TableCell align="right" colSpan={2}>
                                        <b>Week 2</b>
                                    </TableCell>
                                    <TableCell align="right" colSpan={2}>
                                        <b>Week 3</b>
                                    </TableCell>
                                    <TableCell align="right" colSpan={2}>
                                        <b>Week 4</b>
                                    </TableCell>

                                    <TableCell align="right" colSpan={2}>
                                        <b>Grand Total</b>
                                    </TableCell>
                                </TableRow>

                                {/* ===== COLUMN HEADER ===== */}
                                <TableRow>
                                    <TableCell align="right"><b>COLLECTION TARGET</b></TableCell>
                                    <TableCell align="right"><b>COLLECTION RECEIVED</b></TableCell>

                                    <TableCell align="right"><b>COLLECTION TARGET</b></TableCell>
                                    <TableCell align="right"><b>COLLECTION RECEIVED</b></TableCell>

                                    <TableCell align="right"><b>COLLECTION TARGET</b></TableCell>
                                    <TableCell align="right"><b>COLLECTION RECEIVED</b></TableCell>

                                    <TableCell align="right"><b>COLLECTION TARGET</b></TableCell>
                                    <TableCell align="right"><b>COLLECTION RECEIVED</b></TableCell>

                                    <TableCell align="right"><b>COLLECTION TARGET</b></TableCell>
                                    <TableCell align="right"><b>COLLECTION RECEIVED</b></TableCell>
                                </TableRow>

                            </TableHead>


                            <TableBody>
                                {areaRows.map((r, i) => (
                                    <TableRow key={i}>
                                        <TableCell>{r.zone}</TableCell>

                                        {/* Week 1 */}
                                        <TableCell align="right">{r.w1_target.toLocaleString()}</TableCell>
                                        <TableCell align="right">{r.w1_received.toLocaleString()}</TableCell>

                                        {/* Week 2 */}
                                        <TableCell align="right">{r.w2_target.toLocaleString()}</TableCell>
                                        <TableCell align="right">{r.w2_received.toLocaleString()}</TableCell>

                                        {/* Week 3 */}
                                        <TableCell align="right">{r.w3_target.toLocaleString()}</TableCell>
                                        <TableCell align="right">{r.w3_received.toLocaleString()}</TableCell>

                                        {/* Week 4 */}
                                        <TableCell align="right">{r.w4_target.toLocaleString()}</TableCell>
                                        <TableCell align="right">{r.w4_received.toLocaleString()}</TableCell>

                                        {/* Grand Total */}
                                        <TableCell align="right">{r.total_target.toLocaleString()}</TableCell>
                                        <TableCell align="right">{r.total_received.toLocaleString()}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>

                        </Table>
                    </TableContainer>
                </Paper>
            </div >
        </ZoomWrapper >
    );
};

export default CollectionTargetAchvReport;
